// Screen heading, the linked shared-setting banner, and API error alerts.

import React from 'react';
import PropTypes from 'prop-types';
import Pencil from '@decisiv/iconix/lib/components/Pencil';
import { Alert, Button, Grid } from '@decisiv/ui-components';
import { H3, P } from '@decisiv/ui-components/lib/components/Typography';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { t, Trans } from '@lingui/macro';

import { SectionRow, SharedSettingsBanner } from '../StyledComponents';
import CommandIconAndTitle from '../CommandIconAndTitle';
import { SETTINGS_PAGE_INPUT_PAYLOAD_TEXT } from '../../common/constants/staticTexts';

const FormHeader = ({
  integrationName = '',
  readOnly,
  onEdit,
  linkedSourceData = null,
  onLoadLinkedValues,
  onDismissLinkedValues,
  apiErrors = [],
  onOpenSchemaDetails,
}) => (
  <>
    <SectionRow>
      <Grid.Column span="10">
        <Flex>
          <Flex flexDirection="column">
            <H3>
              <Trans>Location Settings</Trans>
            </H3>
            <P shade={1} size="small">
              <Trans>Configure the location settings for</Trans>
              &nbsp;{integrationName}&nbsp;
              <Trans>integration. All fields marked * are required.</Trans>
            </P>
          </Flex>
        </Flex>
      </Grid.Column>
      {readOnly && (
        <Grid.Column span="2">
          <Flex justifyContent="right">
            <Button
              icon={Pencil}
              text={t`Edit`}
              kind="secondary"
              onClick={onEdit}
            />
          </Flex>
        </Grid.Column>
      )}
    </SectionRow>

    {!readOnly && linkedSourceData && (
      <SectionRow>
        <Grid.Column span="12">
          <SharedSettingsBanner>
            <P marginBottom={0.5}>
              <Trans>
                This integration is linked to{' '}
                <strong>{linkedSourceData.partnerName}</strong> via{' '}
                <strong>{linkedSourceData.settingName}</strong>. Load attribute
                values from that location?
              </Trans>
            </P>
            <Flex>
              <Button
                text={t`Load Values`}
                size="small"
                onClick={onLoadLinkedValues}
              />
              <Button
                text={t`Dismiss`}
                kind="secondary"
                size="small"
                style={{ marginLeft: '0.5rem' }}
                onClick={onDismissLinkedValues}
              />
            </Flex>
          </SharedSettingsBanner>
        </Grid.Column>
      </SectionRow>
    )}

    {apiErrors.map((error) => (
      <SectionRow key={error?.detail}>
        <Grid.Column span="12">
          <Alert intent="danger" title={t`Error Saving Changes`} dismissable>
            {error?.detail}
          </Alert>
        </Grid.Column>
      </SectionRow>
    ))}

    <SectionRow key="InputPayload">
      <Grid.Column span="2">
        <CommandIconAndTitle
          title={t`InputPayload`}
          onClick={() => onOpenSchemaDetails(t`InputPayload`)}
        />
      </Grid.Column>
      <Grid.Column>
        <P shade={1} style={{ marginTop: 7 }}>
          <Trans>{SETTINGS_PAGE_INPUT_PAYLOAD_TEXT}</Trans>
        </P>
      </Grid.Column>
    </SectionRow>
  </>
);

FormHeader.propTypes = {
  integrationName: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  linkedSourceData: PropTypes.object,
  onLoadLinkedValues: PropTypes.func.isRequired,
  onDismissLinkedValues: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  apiErrors: PropTypes.array,
  onOpenSchemaDetails: PropTypes.func.isRequired,
};
export default FormHeader;
